import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage, injectIntl } from 'react-intl'

import acl from '../../../../../../../../../services/acl'

import OwnershipComponent from '../../Ownership'

import { LOCALE_PREFIX_OWNERSHIP } from './constants'

import config from '../../../../../../../../../config'

import hocDialog from '../../../../../../../../../services/dialog/hocDialog'
import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import hocConnect from './hocConnect'

@hocBlock(config.modules.report.key, { levelReload: true })
@acl
@hocConnect
@hocDialog
@injectIntl
export default class Ownership extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        openDialog: PropTypes.func,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const {
            module,
            block,
            customData,
            id,
            openDialog,
            data,
            intl: { formatMessage },
        } = this.props

        return (
            <div className={cx('block-ownership')}>
                <OwnershipComponent
                    module={module}
                    block={block}
                    customData={customData}
                    openDialog={openDialog}
                    mainId={id}
                    data={data}
                    renderBanner={this.renderBanner}
                    translates={{
                        historyTitle: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.historyTitle`} />,
                        owns: formatMessage({ id: `${LOCALE_PREFIX_OWNERSHIP}.owns` }),
                        holdingTitle: formatMessage({ id: `${LOCALE_PREFIX_OWNERSHIP}.holdingTitle` }),
                        isOwned: formatMessage({ id: `${LOCALE_PREFIX_OWNERSHIP}.isOwned` }),
                        from: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.from`} />,
                        to: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.to`} />,
                        notIdentified: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.notIdentified`} />,
                        noData: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.noData`} />,
                        bannerLineText: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.bannerLineText`} />,
                        bannerButtonText: <FormattedMessage id={`${LOCALE_PREFIX_OWNERSHIP}.bannerButtonText`} />,
                    }}
                />
            </div>
        )
    }
}
